/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After calibration it is accurate to within the precision of your slide adjustment — typically well under a millimetre. Without calibrating, it uses a best-guess default that may be off by 10–30% on high-density screens.`)
};

const es_ruler_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tras calibrar, es precisa dentro del margen de tu ajuste al deslizar — normalmente muy por debajo de un milímetro. Sin calibrar, usa un valor predeterminado estimado que puede fallar entre un 10 % y un 30 % en pantallas de alta densidad.`)
};

const de_ruler_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach der Kalibrierung ist es so genau wie deine Reglereinstellung — typischerweise deutlich unter einem Millimeter. Ohne Kalibrierung wird ein bestmöglicher Standardwert verwendet, der bei Bildschirmen mit hoher Pixeldichte um 10–30 % abweichen kann.`)
};

const nl_ruler_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na kalibratie is hij nauwkeurig tot op de precisie van je schuifafstelling — meestal ruim onder een millimeter. Zonder kalibratie gebruikt hij een standaardschatting die op schermen met hoge dichtheid 10-30% kan afwijken.`)
};

const fr_ruler_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Après calibration, elle est précise dans la limite de votre ajustement au curseur — généralement bien en dessous d'un millimètre. Sans calibration, elle utilise une valeur par défaut approximative qui peut être décalée de 10 à 30 % sur les écrans à haute densité.`)
};

const it_ruler_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopo la calibrazione è preciso entro il margine del tuo aggiustamento — in genere ben sotto il millimetro. Senza calibrazione, usa un valore predefinito stimato che può sbagliare del 10–30% su schermi ad alta densità.`)
};

const pt_br2_ruler_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois da calibração, ela é precisa dentro da margem do seu ajuste manual — geralmente bem abaixo de um milímetro. Sem calibrar, ela usa um valor padrão estimado que pode errar de 10% a 30% em telas de alta densidade.`)
};

const pt_ruler_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois da calibração, é precisa dentro da margem do seu ajuste de deslize — normalmente muito menos de um milímetro. Sem calibrar, usa um valor padrão estimado que pode falhar 10–30% em ecrãs de alta densidade.`)
};

const ja_ruler_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`校正後は、スライド調整の精度の範囲内 — 通常は1ミリメートル以下の誤差 — で正確になります。校正しない場合は既定の推定値が使われ、高密度画面では10〜30%ずれることがあります。`)
};

const zh_ruler_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`校准后，精确度取决于你滑动调整的精度——通常误差远小于一毫米。若不校准，则使用默认估算值，在高密度屏幕上可能偏差 10%–30%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_faq_a2", locale)
	if (locale === "en") return en_ruler_faq_a2(inputs)
	if (locale === "es") return es_ruler_faq_a2(inputs)
	if (locale === "de") return de_ruler_faq_a2(inputs)
	if (locale === "nl") return nl_ruler_faq_a2(inputs)
	if (locale === "fr") return fr_ruler_faq_a2(inputs)
	if (locale === "it") return it_ruler_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_faq_a2(inputs)
	if (locale === "pt") return pt_ruler_faq_a2(inputs)
	if (locale === "ja") return ja_ruler_faq_a2(inputs)
	return zh_ruler_faq_a2(inputs)
};